export default "__VITE_ASSET__BFa$raPY__"